/*
 * @Date: 2023-03-08 15:21:15
 * @LastEditors: Leo
 * @LastEditTime: 2023-05-18 18:54:28
 * @FilePath: \3.0-manger\src\js\components\private-search.js
 */
const template = document.createElement("template");
template.innerHTML = `
    <style>
    .visually-hidden {display: none;}
     /*scrollbar */
    ::-webkit-scrollbar {
        height: 8px;
        width: 7px;
    }
    ::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 5%);
    }
    ::-webkit-scrollbar-thumb {
        background-color: rgba(144, 147, 153, 30%);
        border-radius: 2px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 20%);
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: #b6b7b9;
    }

    .header-search__private {
      --rem: 16px;
      }
      .header-search__loading-state {display:none;}
      input::-webkit-clear-button,
      input::-moz-clear {
        display: none;
      }
      input::-webkit-search-cancel-button,
      input::-webkit-search-decoration,
      input::-moz-search-clear-button {
        display: none;
      }
      .header-search {
        display: none;
        position: absolute;
        top: calc(100% + var(--rem) * 0.1);
        max-width: 40vw;
        width: 100%;
        left: 0;
        top: 100%;
        background-color: rgb(255, 255, 255);
        z-index: 3;
        border-radius: 0px 0px 12px 12px;
        overflow: hidden;
      }
      .header-search .hidden{
        display: none;
      }
      .recommend-search-list{
        display: none;
        background-color: #fff;
        padding-bottom: 20px;
        border-radius: 0 0 12px 12px;
      }
      .recommend-search-list .predictive-search__results-list{
        max-height: 450px;
        overflow-y: auto;
      }
      .recommend-search-list .predictive-search__item{
        padding: 14px calc(2* var(--rem));
      }
      .recommend-search-list a{
        font-size: 14px;
        color: #333;
      }
      
      @media screen and (max-width: 749px) {
        .header-search--header {
            right: 0;
            left: 0;
            top: 100%;
        }
      }
      @media screen and (max-width: 989px) {
        .header-search {
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }
      }
      .header-search-wrapper {
        position: relative;
      }
      @media screen and (min-width: 1024px) {
        .header-search {
            border-top: none;
        }
      }
      .header-search-wrapper[open] .header-search,
      .header-search-wrapper[loading] .header-search
      {
          display: block;
      }
      .header-search-wrapper[open] .search-modal__form,
        .header-search-wrapper[loading] .search-modal__form {
          background: #fff;
          border-radius: 0px 0px 12px 12px;
          overflow: hidden;
      }
      @media screen and (max-width: 1024px) {
        ::-webkit-scrollbar {
            height: unset;
            width: unset;
            max-width: 4px;
        }
        ::-webkit-scrollbar-track {
            background-color: unset;
        }
        ::-webkit-scrollbar-thumb {
            background-color: unset;
            border-radius: unset;
            box-shadow: unset;
        }
        ::-webkit-scrollbar-thumb:hover {
            background-color: unset;
        }
        .header-search--header {
            right: 0;
            left: 0;
            top: 100%;
        }
        .header-search {
          max-width: 100%;
        }
        .recommend-search-list .predictive-search__results-list{
           max-height: 225px;
        }
      }
      
      .predictive-search__heading {
        border-bottom: 1px solid rgba(18, 18, 18, 0.08);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 4 * var(--rem));
        color: rgba(18, 18, 18, 0.7);
        font-size: 13px;
        line-height: 35px;
      }
      .header-search-wrapper .spinner {
        width: calc(var(--rem) * 1.5);
        height: calc(var(--rem) * 1.5);
          line-height: 0;
      }

      .predictive-search__heading .spinner {
        margin: 0 calc(var(--rem) * 0.2) 0 calc(var(--rem) * 2);
      }

      .header-search-wrapper:not([loading]) .predictive-search__heading .spinner,
      .header-search-wrapper:not([loading]) .predictive-search__loading-state,
      .header-search-wrapper:not([loading]) .predictive-search-status__loading {
          display: none;
      }
      .header-search-wrapper[loading] .predictive-search__loading-state {
          display: flex;
          justify-content: center;
          padding: var(--rem);
      }
      .header-search-wrapper[loading] .predictive-search__heading~.predictive-search__loading-state,
      .header-search-wrapper[loading] .predictive-search__results-list:first-child {
          display: none;
      }
      .predictive-search__results-list {margin: 0;padding-left: 0;}
      .predictive-search__list-item {list-style: none;}
      .predictive-search__list-item[aria-selected="true"]>*,
      .predictive-search__list-item:hover>* {
          color: rgb(18, 18, 18);
          background-color: rgba(18, 18, 18, 0.04);
      }

      .predictive-search__list-item[aria-selected="true"] .predictive-search__item-heading,
      .predictive-search__list-item:hover .predictive-search__item-heading {
          text-underline-offset: calc(var(--rem) * 0.3);
      }
      .predictive-search__item-heading {font-weight: normal;}
      .predictive-search__item {
          display: flex;
          padding: 14px 25px;
          text-align: left;
          text-decoration: none;
          width: 100%;
          box-sizing: border-box;
      }
      
      .predictive-search__item--link {
          display: grid;
          grid-template-columns:calc(var(--rem) * 5) 1fr;
          grid-template-areas: 'product-image product-content';
      }
      
      .predictive-search__item-content {
          grid-area: product-content;
          display: flex;
          flex-direction: column;
      }
      .predictive-search__item-content--centered {
          justify-content: center;
      }
      
      .predictive-search__item-vendor {
        font-size: calc(var(--rem) * 0.9);
      }
      
      .predictive-search__item-heading {
          margin: 0;
          font-size: 14px;
          color: #333;
      }
      
      .predictive-search__item .price {
          color: rgba(18, 18, 18, 0.7);
          font-size: calc(var(--rem) * 1.2);
      }
      
      .predictive-search__item-vendor+.predictive-search__item-heading,
      .predictive-search .price {
        margin-top: calc(var(--rem) * 0.5);
      }
      .predictive-search__item--term {
        justify-content: space-between;
        align-items: center;
        word-break: break-word;
        line-height: 1;
        font-size: 14px;
        outline: none;
        border: none;
        cursor: pointer;
      }
      @media screen and (min-width: 750px) {
        .predictive-search__item--term {
          padding-top:var(--rem);
          padding-bottom: var(--rem);
        }
      }
      .predictive-search__item--term .icon-arrow {
          width: 14px;
          height: 14px;
          flex-shrink: 0;
          margin-left: calc(1.0 * var(--rem) * 2);
          color: rgb(18, 18, 18);
      }
      
      .predictive-search__image {
          grid-area: product-image;
          object-fit: contain;
          font-family: 'object-fit: contain';
      }




      .search-modal__form {
        width: 100%;
      }
      .search__input {
        padding: 13px 56px;
        font-size: 18px;
        color: #333;
        line-height: 24px;
        width: 100%;
        border: none;
        outline: none;
      }
      .field {
        display: flex;
        border: 1px solid #ccc;
        position: relative;
        border-radius: 25px;
        overflow: hidden;
      }
      @media screen and (max-width: 1024px) {
        .search__input {
          padding: 0 44px;
          width: calc(100% - 88px);
          height: 32px;
          line-height: 32px;
          font-size: 16px;
          font-weight: normal;
        }
        .field {
          border-radius: 16px;
        }
        .predictive-search__item-content {
          padding-right: 38px;
        }
      }



      .search__button {
        position: absolute;
        left: 24px;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        outline: none;
        border: none;
      }
      .search-modal__close-button {
        position: absolute;
        background: transparent;
        outline: none;
        border: none;
        top: 50%;
        right: 24px;
        transform: translateY(-50%);
      }
      .search__button svg, .search-modal__close-button svg {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
      .search__button:hover svg path, .search-modal__close-button:hover svg path {
        fill: #fd5000;
      }
      @media screen and (min-width: 990px) {
        .search-modal__form {
          max-width: 40vw;
        }

        .search-modal__close-button {
          margin-left: calc(var(--rem) * 0.5);
        }
      }

      @media screen and (max-width: 1024px) {
        .search__button svg, .search-modal__close-button svg {
          width: 14px;
          height: 14px;
        }
        .search__button:hover svg path, .search-modal__close-button:hover svg path {
          fill: #333;
        }
        .search__button {
          left: 10px;
        }
        .search-modal__close-button {
          right: 10px;
        }
      }
    </style>

    <form 
        action="/search" 
        method="get" 
        role="search" 
        class="search search-modal__form"
    >
        <div class="field">
          <input 
            class="search__input 
            field__input" 
            id="Search-In-Modal" 
            type="text" name="q" value=""
            placeholder="" 
            role="combobox" aria-expanded="false"
            aria-owns="header-search-results-list" aria-controls="header-search-results-list"
            aria-haspopup="listbox" aria-autocomplete="list" autocorrect="off" autocomplete="off" autocapitalize="off"
            spellcheck="false" aria-activedescendant=""
        >
          <input type="hidden" name="options[prefix]" value="last">
          <input type="hidden" name="type" value="product">
          <button class="search__button field__button" aria-label="Search">
            <svg class="icon" width="20" height="20" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="编组-39">
                        <rect id="矩形备份-11" fill="transparent" x="0" y="0" width="20" height="20" rx="2"></rect>
                        <g id="编组-5" transform="translate(1.000000, 1.000000)" fill="#575B66" fill-rule="nonzero" opacity="0.9">
                            <path d="M8.14232039,0 C12.6392761,0 16.2846408,3.61605674 16.2846408,8.07685776 C16.2846408,9.99392371 15.611223,11.7551538 14.4866249,13.1400974 C14.5794448,13.1578006 14.6647342,13.2028343 14.7313734,13.2693271 L17.779475,16.2929226 C17.9664524,16.4784527 17.9664524,16.779197 17.779475,16.9647271 L17.1022256,17.6365316 C16.9151917,17.8220057 16.6120099,17.8220057 16.4249761,17.6365316 L13.3768745,14.6129361 C13.3098017,14.5467277 13.2641165,14.4622115 13.2456394,14.3701553 C11.8007577,15.5270769 9.99917961,16.1567109 8.14232039,16.1537155 C3.64536472,16.1537155 0,12.5376588 0,8.07685776 C0,3.61605672 3.64536474,0 8.14232039,0 Z M8.14232039,1.90043712 C4.70338742,1.90043712 1.91584009,4.66557313 1.91584009,8.07685776 C1.91584009,11.4881424 4.70338742,14.2532784 8.14232039,14.2532784 C11.5812533,14.2532784 14.3688007,11.4881424 14.3688007,8.07685776 C14.3688007,4.66557311 11.5812534,1.90043712 8.14232039,1.90043712 Z" id="形状"></path>
                        </g>
                    </g>
                </g>
            </svg>
          </button>

          <button 
            type="button" 
            class="search-modal__close-button 
            modal__close-button 
            link link--text 
            focus-inset"
            aria-label="Close"
          >
            <svg 
              t="1690868656601" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="2324" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
              <path
                d="M952.311261 921.328619 542.892591 510.919389 950.154131 102.671381c8.53028-8.55177 8.53028-22.416546 0-30.967292-8.532327-8.55177-22.360264-8.55177-30.892591 0l-407.262564 408.248008L104.737436 71.704089c-8.53028-8.55177-22.36231-8.55177-30.892591 0-8.529257 8.55177-8.529257 22.416546 0 30.967292l407.262564 408.248008L71.687716 921.328619c-8.529257 8.55177-8.529257 22.416546 0 30.967292 4.26514 4.27435 9.856485 6.41306 15.446807 6.41306 5.590322 0 11.181667-2.13871 15.446807-6.41306l409.41867-410.409231 409.41867 410.409231c4.266164 4.27435 9.855462 6.41306 15.446807 6.41306 5.591345 0 11.17962-2.13871 15.446807-6.41306C960.841541 943.745165 960.841541 929.879366 952.311261 921.328619z"
                fill="#272636" p-id="2325"></path>
            </svg>
          </button>
        </div>
        <div class="recommend-search-list"></div>
        <div 
            class="header-search header-search--header" 
            tabindex="-1" data-header-search
        >
          <div class="header-search__loading-state">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </div>
        <span class="header-search-status visually-hidden" role="status" aria-hidden="true"></span>
      </form>
`

export default class HeaderSearch extends HTMLElement {
    constructor() {
        super();

        this.innerDOM = document.createElement("div")
        this.innerDOM.classList.add("header-search-wrapper")
        if(this.getAttribute("data-class")) {
          this.innerDOM.classList.add(this.getAttribute("data-class"))
        }
        this.innerDOM.appendChild(template.content.cloneNode(true))

        this.innerDOM.querySelector(".search .search__input").setAttribute("placeholder", this.getAttribute("data-placeholder-text"))


        this.cachedResults = {};
        this.input = this.innerDOM.querySelector('input[type="text"]');
        this.recommendList = this.innerDOM.querySelector('.recommend-search-list');
        this.predictiveSearchResults = this.innerDOM.querySelector('[data-header-search]');
        this.isOpen = false;

        this.setupEventListeners();

        let shadow = this.attachShadow({
          mode: 'open'
        })
        shadow.appendChild(this.innerDOM)

        this.renderRecommendList();

        const _self = this
        this.innerDOM.querySelector(".search-modal__close-button").addEventListener("click", function() {
            document.querySelector(".header-search__private").classList.add('fade-out');
            document.querySelector(".header-search__private").querySelector('.modal-content').classList.add('slide-out');
            setTimeout(function () {
              document.querySelector(".header-search__private").style.display = 'none';
              document.querySelector(".header-search__private").classList.remove('fade-out');
              document.querySelector("body").classList.remove('overflow-hidden');
              document.querySelector(".header-search__private").querySelector('.modal-content').classList.remove('slide-out');
            }, 300);
            _self.close()
        })

        // 推荐搜索词点击事件
        this.innerDOM.querySelectorAll(".recommend-search-list a.predictive-search__item").forEach((item) => {
            item.addEventListener("click", function() {
                _self.input.value = this.text;
                _self.input.focus();
            })
        })
    }

    // 监听打开 - [hd-open] 变化即打开
    static get observedAttributes() {
      return ['hd-open'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'hd-open') {
        this.open()
      }
    }

    setupEventListeners() {
        const form = this.innerDOM.querySelector('form.search');
        form.addEventListener('submit', this.onFormSubmit.bind(this));

        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        const searchTerm = this.getQuery();

        // 显示或隐藏推荐搜索词列表
        this.toggleRecommendList(searchTerm.length === 0);

        this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
        // if (!this.getQuery().length || this.innerDOM.querySelector('[aria-selected="true"] a')) event.preventDefault();
        if (this.innerDOM.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFocus() {
        const searchTerm = this.getQuery();

        // 显示或隐藏推荐搜索词列表
        this.toggleRecommendList(searchTerm.length === 0);

        if (!searchTerm.length) return;

        if (this.getAttribute('results') === 'true') {
            this.open();
        } else {
            this.getSearchResults(searchTerm);
        }
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    onKeyup(event) {
        if (!this.getQuery().length) this.close(true);
        event.preventDefault();

        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up')
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break;
        }
    }

    onKeydown(event) {
        // Prevent the cursor from moving in the input when using the up and down arrow keys
        if (
            event.code === 'ArrowUp' ||
            event.code === 'ArrowDown'
        ) {
            event.preventDefault();
        }
    }

    switchOption(direction) {
        if (!this.getAttribute('open')) return;

        const moveUp = direction === 'up';
        const selectedElement = this.innerDOM.querySelector('[aria-selected="true"]');
        const allElements = this.innerDOM.querySelectorAll('li');
        let activeElement = this.innerDOM.querySelector('li');

        if (moveUp && !selectedElement) return;

        this.statusElement.textContent = '';

        if (!moveUp && selectedElement) {
            activeElement = selectedElement.nextElementSibling || allElements[0];
        } else if (moveUp) {
            activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
        }

        if (activeElement === selectedElement) return;

        activeElement.setAttribute('aria-selected', true);
        if (selectedElement) selectedElement.setAttribute('aria-selected', false);

        this.setLiveRegionText(activeElement.textContent);
        this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
        const selectedProduct = this.innerDOM.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

        if (selectedProduct) selectedProduct.click();
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        this.setLiveRegionLoadingState();

        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }

        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${window.pageInfo.search_query || "product,article"}&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close(false);
                    // fix no support lang

                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                this.cachedResults[queryKey] = resultsMarkup;
                this.renderSearchResults(resultsMarkup);
            })
            .catch((error) => {
                this.close(false);
                throw error;
            });
    }

    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.innerDOM.querySelector('.header-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;

        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true');
        }, 1000);
    }

    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', true);

        this.setLiveRegionResults();
        this.open();
    }

    setLiveRegionResults() {
      this.innerDOM.removeAttribute('loading');
        this.setLiveRegionText(this.innerDOM.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }

    getResultsMaxHeight() {
        // this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
        this.resultsMaxHeight = window.innerHeight * 0.7
        return this.resultsMaxHeight;
    }

    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.innerDOM.setAttribute('open', true);
        this.input.setAttribute('aria-expanded', true);
        this.isOpen = true;
        setTimeout(() => {
            this.input.focus()
        }, 10);
    }

    close(clearSearchTerm = true) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results');
        }

        const selected = this.innerDOM.querySelector('[aria-selected="true"]');

        if (selected) selected.setAttribute('aria-selected', false);

        this.input.setAttribute('aria-activedescendant', '');
        this.innerDOM.removeAttribute('open');
        this.input.setAttribute('aria-expanded', false);
        this.resultsMaxHeight = false
        this.predictiveSearchResults.removeAttribute('style');

        this.isOpen = false;
        this.innerDOM.removeAttribute('loading');
    }

    /**
     * 渲染推荐关键词
     */
    renderRecommendList() {
    if (!window.websiteRecommendSearch) { return; }

    let listHtml = '';
    window.websiteRecommendSearch.list.forEach((item) => {
    listHtml += `<li class="predictive-search__list-item"><a class="predictive-search__item" href="${item.link}" target="_blank">${item.title}</a></li>`;
    })

    const recommendListHtml = `
      <h2 class="predictive-search__heading">${window.websiteRecommendSearch.title}</h2>
      <ul class="predictive-search__results-list">${listHtml}</ul>`;

    this.recommendList.innerHTML = recommendListHtml;
    }

    /**
     * 显示或隐藏推荐词列表
     * @param flag true/false
     */
    toggleRecommendList(flag) {
        if (!window.websiteRecommendSearch) { return; }
        if (flag) {
            this.recommendList.style.display = 'block';
        } else {
            this.recommendList.style.display = 'none';
        }
    }
}
